<script>
  import { inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let { slots = [] } = $props();

  const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function cadence(slot) {
    const days = [...slot.days_of_week].sort().map((d) => DAY_LABELS[d]).join(', ');
    return `${days || 'No days set'} at ${slot.time_of_day}`;
  }
</script>

<AppLayout title="Slots">
  <div class="flex justify-end mb-6">
    <Button href="/slots/new"><Icon icon="mdi:plus" class="mr-1" /> New slot</Button>
  </div>

  {#if slots.length === 0}
    <Card>
      <div class="text-center py-8">
        <Icon icon="mdi:calendar-clock-outline" class="text-4xl text-secondary-300 mx-auto mb-3" />
        <p class="text-secondary-500 mb-4">No slots yet. A slot is a recurring time that needs a post filled in.</p>
        <Button href="/slots/new">Create your first slot</Button>
      </div>
    </Card>
  {:else}
    <div class="flex flex-col gap-3">
      {#each slots as slot}
        <a use:inertia href={`/slots/${slot.id}`} class="card !p-5 hover:border-primary-200 flex items-center justify-between gap-4">
          <div class="flex items-center gap-3">
            <Icon icon="mdi:calendar-clock-outline" class="text-secondary-400 text-xl" />
            <div>
              <div class="text-secondary-800 font-medium">{slot.name}</div>
              <div class="text-xs text-secondary-500">{cadence(slot)}</div>
            </div>
          </div>
          <div class="flex items-center gap-3">
            {#if !slot.active}
              <span class="text-xs text-secondary-400">Paused</span>
            {/if}
            <StatusBadge status={slot.mode === 'automatic' ? 'scheduled' : 'pending'} />
          </div>
        </a>
      {/each}
    </div>
  {/if}
</AppLayout>
